import axiosService from "../../services/axios/axios.service";

interface DayOffQuery {
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
    search?: string;
}

export interface DayOffData {
    reason: string;
    note?: string;
    startDate: Date;
    endDate: Date;
}

const getDayOff = async (query: DayOffQuery): Promise<NonNullable<any[]>> => {
    const response = await axiosService.get("/day-off/get-day-off", { params: query });
    return response.data;
}

const createDayOff = async (data: DayOffData): Promise<NonNullable<any>> => {
    const response = await axiosService.post("/day-off/create", data);
    return response.data;
}

const deleteDayOff = async (id: string): Promise<NonNullable<any>> => {
    const response = await axiosService.delete(`/day-off/delete/${id}`);
    return response.data;
}

const updateDayOff = async (id: string, data: DayOffData): Promise<NonNullable<any>> => {
    const response = await axiosService.patch(`/day-off/update/${id}`, data);
    return response.data;
}

export { getDayOff, createDayOff, deleteDayOff, updateDayOff };